// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-form { 
    box-sizing: border-box;
    max-width: 700px;
    margin: 0 auto;
}
.group-form .group-form__group-image {
    display: block;
    margin: 0 auto;
    width: 200px;
    text-align: center;
}
.group-form .group-form__group-image svg.placeholder {
    display: block;
    width: 200px;
    margin: 10px auto;
    color: var(--main-border-color);
}
.group-form .group-form__type svg {
    width: 1em;
    height: 1em;
    margin-right: 0.2em;
    margin-bottom: -0.2em;
}
.group-form .group-form__controls {
    text-align: center;
}

`, "",{"version":3,"sources":["webpack://./client/components/groups/form/GroupForm.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,cAAc;IACd,cAAc;IACd,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;AACnC;AACA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".group-form { \n    box-sizing: border-box;\n    max-width: 700px;\n    margin: 0 auto;\n}\n.group-form .group-form__group-image {\n    display: block;\n    margin: 0 auto;\n    width: 200px;\n    text-align: center;\n}\n.group-form .group-form__group-image svg.placeholder {\n    display: block;\n    width: 200px;\n    margin: 10px auto;\n    color: var(--main-border-color);\n}\n.group-form .group-form__type svg {\n    width: 1em;\n    height: 1em;\n    margin-right: 0.2em;\n    margin-bottom: -0.2em;\n}\n.group-form .group-form__controls {\n    text-align: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
